import React, { useEffect, useState } from 'react';
import { getData, postData, putData, deleteData } from '../helpers/ApiSettings';

const WorkshopCategories = () => {
	const [categories, setCategories] = useState([]);
	const [newCategory, setNewCategory] = useState({ name: '', description: '' });
	const [editingCategory, setEditingCategory] = useState(null);

	const fetchCategories = async () => {
		try {
			const response = await getData('/workshop-categories');
			setCategories(response.data.data);
		} catch (error) {
			console.error('Erreur chargement catégories :', error);
		}
	};

	useEffect(() => {
		fetchCategories();
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			if (editingCategory) {
        const { id, ...categoryData } = editingCategory;
				await putData(`/workshop-categories/${editingCategory.id}`, {
					data: categoryData
				});
				setEditingCategory(null);
			} else {
				await postData('/workshop-categories', {
					data: newCategory
				});
				setNewCategory({ name: '', description: '' });
			}
			fetchCategories();
		} catch (error) {
			console.error('Erreur lors de la sauvegarde :', error);
		}
	};

	const handleDelete = async (id) => {
		if (window.confirm('Supprimer cette catégorie ?')) {
			try {
				await deleteData(`/workshop-categories/${id}`);
				fetchCategories();
			} catch (error) {
				console.error('Erreur suppression catégorie :', error);
			}
		}
	};

	const handleCancelEdit = () => {
		setEditingCategory(null);
	};

	return (
		<div className="container mt-4">
			<h2 className="h4 mb-4">Catégories d'ateliers</h2>
			<form onSubmit={handleSubmit} className="mb-4">
				<div className="row g-2 align-items-end">
					<div className="col-md-4">
						<input
							type="text"
							className="form-control"
							placeholder="Nom"
							value={editingCategory ? editingCategory.name : newCategory.name}
							onChange={(e) => editingCategory ? setEditingCategory({ ...editingCategory, name: e.target.value }) : setNewCategory({ ...newCategory, name: e.target.value })}
							required
						/>
					</div>
					<div className="col-md-4">
						<input
							type="text"
							className="form-control"
							placeholder="Description"
							value={editingCategory ? editingCategory.description : newCategory.description}
							onChange={(e) => editingCategory ? setEditingCategory({ ...editingCategory, description: e.target.value }) : setNewCategory({ ...newCategory, description: e.target.value })}
						/>
					</div>
					<div className="col-md-2">
						<button type="submit" className="btn btn-primary w-100">
							{editingCategory ? 'Mettre à jour' : 'Ajouter'}
						</button>
					</div>
					{editingCategory && (
						<div className="col-md-2">
							<button type="button" className="btn btn-secondary w-100" onClick={handleCancelEdit}>
								Annuler
							</button>
						</div>
					)}
				</div>
			</form>

			<div className="card">
				<div className="card-body p-0">
					<table className="table mb-0">
						<thead>
							<tr>
								<th>Nom</th>
								<th>Description</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{categories.map((cat) => (
								<tr key={cat.id}>
									<td>{cat.name}</td>
									<td>{cat.description}</td>
									<td>
										<button
											className="btn btn-sm btn-info me-2"
											onClick={() => setEditingCategory({ id: cat.documentId, name: cat.name, description: cat.description })}
										>
											Modifier
										</button>
										<button className="btn btn-sm btn-danger" onClick={() => handleDelete(cat.documentId)}>
											Supprimer
										</button>
									</td>
								</tr>
							))}
							{categories.length === 0 && (
								<tr>
									<td colSpan="3" className="text-center text-muted">Aucune catégorie</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default WorkshopCategories;
